export interface AddButtonInputs {
  count: number;
  hasPurchaseListAccess: boolean;
  maxBatch: number;
  busy: boolean;
}
export interface AddButtonState {
  disabled: boolean;
  tooltip: string;
}

export function resolveAddButtonState(inputs: AddButtonInputs): AddButtonState {
  if (!inputs.hasPurchaseListAccess) {
    return { disabled: true, tooltip: 'Upgrade your plan to use the Purchase List' };
  }
  if (inputs.busy) {
    return { disabled: true, tooltip: 'Adding...' };
  }
  if (inputs.count > inputs.maxBatch) {
    return { disabled: true, tooltip: `Maximum ${inputs.maxBatch} items per batch` };
  }
  return { disabled: false, tooltip: '' };
}
